import { initColorSelect, doAjax, updateTableValue, initRedPointLogic } from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'


const initDecoWoodSelectLogic = () => {
	initColorSelect()
	loadAlreadyCustomizedOptions();
	initRedPointLogic('decoInlay', 'dot_decoInlay', setImage)
	
}

function setImage(component, colorCode) {
	const setYZ4_A8 = aeo['configuration']['YZ4_A8'] === true
	const set7TZ_A6_C9 = aeo['configuration']['7TZ_A6_C9'] === true
	const set7TN_A6_C9 = aeo['configuration']['7TN_A6_C9'] === true
	const set7TZ_A6etron = aeo['configuration']['7TZ_A6etron'] === true
	const set7TN_A6etron = aeo['configuration']['7TN_A6etron'] === true
	const set7TZ_A5 = aeo['configuration']['7TZ_A5'] === true
	const set7TN_A5 = aeo['configuration']['7TN_A5'] === true

	const carModel = document.querySelector("input[name=carmodel]").value;
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;

	var imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]		
	var imageSourceBack = aeo['images']['decoInlay_' + backSeatModel + '_back_view'][colorCode]

	if ((carModel == 21)) {
		// RSQ8 
		var imageSourceFront = aeo['images']['decoInlay_rsq8_' + frontSeatModel + '_front_view'][colorCode]		
		var imageSourceBack = aeo['images']['decoInlay_rsq8_' + backSeatModel + '_back_view'][colorCode]
		// RSQ8 
	}

	if ((carModel == 23) || (carModel == 25) || (carModel == 26) || (carModel == 27)) {
		// A8 S line, A8 L S line, S8, S8 L: doorarmrest-deco 
		imageSourceFront = aeo['images']['decoInlay_tuerarmauflage_' + frontSeatModel + '_front_view'][colorCode]		
		imageSourceBack = aeo['images']['decoInlay_tuerarmauflage_' + backSeatModel + '_back_view'][colorCode]
		// A8 S line, A8 L S line, S8, S8 L: doorarmrest-deco 
	}	

	if (setYZ4_A8 && ((carModel == 22) || (carModel == 24))) {
		// only A8/A8 L, with YZ4: doorarmrest-deco 
		imageSourceFront = aeo['images']['decoInlay_tuerarmauflage_' + frontSeatModel + '_front_view'][colorCode]		
		imageSourceBack = aeo['images']['decoInlay_tuerarmauflage_' + backSeatModel + '_back_view'][colorCode]
		// only A8/A8 L, with YZ4: doorarmrest-deco 
	}

	if ((set7TZ_A6_C9 || set7TN_A6_C9) && ((carModel == 60) || (carModel == 61) || (carModel == 62) || (carModel == 63) || (carModel == 64) || (carModel == 65))) {
		// only A6 C9
		imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]		
		imageSourceBack = aeo['images']['decoInlay_' + frontSeatModel + '_' + backSeatModel + '_back_view'][colorCode]
		//console.log('7TN_A6_C9: ' + aeo['configuration']['7TN_A6_C9'] + ' 7TZ_A6_C9: ' + aeo['configuration']['7TZ_A6_C9'])
		const packageSelectionOptions = [
			{ option: '7TN_A6_C9', checked: colorCode == 60 },
			{ option: '7TZ_A6_C9', checked: colorCode != 60 }
		];
		
		packageSelectionOptions.forEach(({ option, checked }) => {
			doAjax({
				'package_selection_option': option,
				'checked': checked
			});
		});
	}	

	if ((set7TZ_A6etron || set7TN_A6etron) && ((carModel == 50) || (carModel == 51) || (carModel == 52) || (carModel == 53) || (carModel == 54) || (carModel == 55))) {
		// only A6 etron
		imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]		
		imageSourceBack = aeo['images']['decoInlay_' + backSeatModel + '_back_view'][colorCode]
		//console.log('7TN_A6etron: ' + aeo['configuration']['7TN_A6etron'] + ' 7TZ_A6etron: ' + aeo['configuration']['7TZ_A6etron'])
		const packageSelectionOptions = [
			{ option: '7TN_A6etron', checked: colorCode == 60 },
			{ option: '7TZ_A6etron', checked: colorCode != 60 }
		];
		
		packageSelectionOptions.forEach(({ option, checked }) => {
			doAjax({
				'package_selection_option': option,
				'checked': checked
			});
		});
	}

	if ((set7TZ_A5 || set7TN_A5) && ((carModel == 40) || (carModel == 41) || (carModel == 42) || (carModel == 43) || (carModel == 44) || (carModel == 45))) {
		// only A5 without RS5
		imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]		
		imageSourceBack = aeo['images']['decoInlay_' + backSeatModel + '_back_view'][colorCode]
		//console.log('7TN_A5: ' + aeo['configuration']['7TN_A5'] + ' 7TZ_A5: ' + aeo['configuration']['7TZ_A5'])
		const packageSelectionOptions = [
			{ option: '7TN_A5', checked: colorCode == 60 },
			{ option: '7TZ_A5', checked: colorCode != 60 }
		];
		
		packageSelectionOptions.forEach(({ option, checked }) => {
			doAjax({
				'package_selection_option': option,
				'checked': checked
			});
		});
	}	

	if ((set7TZ_A5 || set7TN_A5) && ((carModel == 46) || (carModel == 47))) {
		// only RS5
		imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]
		imageSourceBack = aeo['images']['decoInlay_' + backSeatModel + '_back_view'][colorCode]
		const packageSelectionOptions = [
			{ option: '7TN_A5', checked: colorCode == 60 },
			{ option: '7TZ_A5', checked: colorCode != 60 }
		];
		
		packageSelectionOptions.forEach(({ option, checked }) => {
			doAjax({
				'package_selection_option': option,
				'checked': checked
			});
		});
	}	

	replaceImage(imageSourceFront, component + 'Color', 'car_frontseat')
	replaceImage(imageSourceBack, component, 'car_backseat')

	updateTableValue(component, colorCode, 'deco-wood-components')
	doAjax({
		'interior_component': component,
		'color': colorCode,
		'src': imageSourceFront
	})

	
}

export { initDecoWoodSelectLogic };